import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const SESSION_KEY = "mlcn_session_id";
const TOKEN_KEY = "mlcn_token";

export function getSessionId() {
    let id = localStorage.getItem(SESSION_KEY);
    if (!id) {
        id = (crypto.randomUUID && crypto.randomUUID()) ||
            "s-" + Math.random().toString(36).slice(2) + Date.now();
        localStorage.setItem(SESSION_KEY, id);
    }
    return id;
}

export function getToken() { return localStorage.getItem(TOKEN_KEY); }
export function setToken(t) {
    if (t) localStorage.setItem(TOKEN_KEY, t);
    else localStorage.removeItem(TOKEN_KEY);
}

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
    const t = getToken();
    if (t) config.headers.Authorization = `Bearer ${t}`;
    return config;
});

// Silent token refresh — if the server slid the expiry forward and handed
// us a fresh token, swap it in transparently. Active users never get
// logged out (same UX as Gmail / Slack). The server only sends this
// header when the current token is past the halfway mark of its TTL.
api.interceptors.response.use((response) => {
    const refreshed = response?.headers?.["x-refreshed-token"] || response?.headers?.["X-Refreshed-Token"];
    if (refreshed && typeof refreshed === "string" && refreshed.length > 20) {
        setToken(refreshed);
    }
    return response;
});

export function formatApiErrorDetail(detail) {
    if (detail == null) return "Something went wrong. Please try again.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail))
        return detail
            .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
            .filter(Boolean)
            .join(" ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}
